const common = require('angular').module('oly.common');

const { formDirectiveDefinition, ngFormDirectiveDefinition } = require('./form.directive');

common.directive('form', formDirectiveDefinition)
    .directive('ngForm', ngFormDirectiveDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/form/index.js